import { Discounts } from './Discounts'
import { OrderElement } from '../summary/getOrderPriceSummary'
import { VariableDiscountConfiguration } from '@ca/common/types'

export const applyDiscountsToElements = (
  elements: Map<string, OrderElement>,
  // For now well assume that the discounts are already filtered based on the requirements
  // and only the applicable ones are passed here
  discounts: VariableDiscountConfiguration[]
) => {
  const result = new Map(elements)

  if (!discounts?.length) {
    return result
  }

  discounts.forEach((discount) => {
    const element = result.get(discount.variable)
    if (!element) {
      return
    }
    result.set(discount.variable, {
      ...element,
      price: Discounts.applyDiscount(element.price, discount),
    })
  })

  return result
}
